const segments = {
  pos: "POS_PAGO",
  pre: "PRE_PAGO",
  controle: "CONTROLE",
};

export default segments;
